import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { AdSheetContainer } from "@/components/AdSheetV2/AdSheetContainer";

const AdSheetV2Page = () => {
  const { sheetId } = useParams<{ sheetId: string }>();

  if (!sheetId) {
    return <Navigate to="/launcher/ad-sheets" replace />;
  }

  return <AdSheetContainer sheetId={sheetId} />;
};

export default AdSheetV2Page;
